import React, { useState, useEffect } from "react";
import FooterB from "../layout/FooterB";
import AboutHeroSection from "../layout/AboutHeroSection";
import AboutBenkyoSection from "../layout/AboutBenkyoSection";
import AboutBenSenseiSection from "../layout/AboutBenSenseiSection";
import AboutFaqSection from "../layout/AboutFaqSection";
import Footer from "../layout/Footer";
import { getAboutPage } from "../../sanityClient";

// import style
import "../../style/pages/about/about.scss";

const componentMap = {
  aboutHeroSection: AboutHeroSection,
  aboutBenkyoSection: AboutBenkyoSection,
  aboutBenSenseiSection: AboutBenSenseiSection,
  aboutFaqSection: AboutFaqSection,
  footerB: FooterB,
  footer: Footer,
};

const About = () => {
  const [pageData, setPageData] = useState({ pageSections: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const data = await getAboutPage();
        if (data) {
          setPageData(data);
        }
      } catch (error) {
        console.error("Error fetching page data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, []);

  const renderSection = (section, index) => {
    const SectionComponent = componentMap[section._type];
    if (!SectionComponent) {
      console.warn(`Unknown section type: ${section._type}`);
      return null;
    }

    switch (section._type) {
      case 'aboutHeroSection':
        return (
          <SectionComponent
            key={section._key || index}
            title={section.title}
            subTitle={section.subTitle}
            backgroundColorClass={section.backgroundColorClass}
            items={section.items}
          />
        );
      case 'footerB':
        return <SectionComponent key={section._key || index} />;
      case 'footer':
        return <SectionComponent key={section._key || index} />;
      case 'aboutBenkyoSection':
        return (
          <SectionComponent
            key={section._key || index}
            id={section.id}
            title={section.title}
            titleSpan={section.titleSpan}
            subtitle={section.subtitle}
            content={section.content}
          />
        );
      case 'aboutBenSenseiSection':
        return (
          <SectionComponent
            key={section._key || index}
            id={section.id}
            title={section.title}
            titleSpan={section.titleSpan}
            subtitle={section.subtitle}
            titleType={section.titleType}
            content={section.content}
          />
        );
      case 'aboutFaqSection':
        return (
          <SectionComponent
            key={section._key || index}
            id={section.id}
            title={section.title}
            titleSpan={section.titleSpan}
            subtitle={section.subtitle}
            titleType={section.titleType}
            content={section.content}
          />
        );
      default:
        return null;
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="about-section">
      {pageData.pageSections && pageData.pageSections.length > 0 &&
        pageData.pageSections.map((section, index) => renderSection(section, index))}
    </div>
  );
};

export default About;
